import { createContext } from 'react';
import { ContentfulCategory, Zone } from '@wbk/contentful/api';

type Option = { id: string; value: string; text: string };

type Props = {
  targetRef?: React.RefObject<HTMLElement | null>;
  categories: ContentfulCategory[] | undefined;
  setSelectedCategory: React.Dispatch<React.SetStateAction<ContentfulCategory | undefined>>;
  selectedCategory: ContentfulCategory | undefined;
  sortBy?: string;
  sortOptions: { id: string; value: string; text: string }[];
  zones: Zone[] | undefined;
  selectedZone: Zone | undefined;
  setSelectedZone: React.Dispatch<React.SetStateAction<Zone | undefined>>;
  categoryOptions: Option[];
  zoneOptions: Option[];
};

const ZonesContext = createContext<Props>({
  targetRef: undefined,
  categories: undefined,
  setSelectedCategory: () => {},
  selectedCategory: undefined,
  sortBy: 'newest',
  sortOptions: [],
  selectedZone: undefined,
  zones: undefined,
  setSelectedZone: () => {},
  categoryOptions: [],
  zoneOptions: [],
});

export default ZonesContext;
